module.exports = __webpack_public_path__ + "public/SideMenuIcons/location.svg?73f9afae";